export default {
    data() {
        return {
            bubble: this.$bubble,
            settings: this.$dealer.user_settings,
            trip: this.$trips
        };
    },
    computed: {

        maintenanceSavings() {
            return this.settings.annualMaintenanceICE - this.settings.annualMaintenanceEV;
        },

    },
    methods: {
        totalSavings(mode) {
            return this.petrolCosts(mode) - this.homeCharging(mode) - this.publicCharging(mode) - this.hybridGetFuelCost(mode) + this.maintenanceSavings;
        },
        drivingkms(mode) {
            return this.getAnnualKms(mode);
        },
        petrolCosts(mode) {
            if (this.bubble.fuelType == "Petrol") {
                return (this.getAnnualKms(mode) / this.settings.petrolConsumption) * this.settings.petrolCost;
            }
    
            return ((this.getAnnualKms(mode) / this.settings.dieselConsumption) * this.settings.dieselCost) + ((this.getAnnualKms(mode) / 1000) * this.settings.RUCperThousand);
        },
        homeCharging(mode) {
            let homeCharging = 0;
            if (mode == "home" || mode == "both") {
                homeCharging += this.getHomeChargingCost(this.car, this.bubble.kms / 7, 365);
            }
            if (mode == "trips" || mode == "both") {
                for (let trip of this.trips) {
                    if (trip.distance) {
                        homeCharging += this.getHomeChargingCost(this.car, trip.distance / 1000, this.annualFrequency(trip));
                    }
                }
            }
            return homeCharging;
        },
        publicCharging(mode) {
            let publicCharging = 0;
            if (mode == "home" || mode == "both") {
                publicCharging += this.getPublicChargingCost(this.car, this.bubble.kms / 7, 365);
            }
            if (mode == "trips" || mode == "both") {
                for (let trip of this.trips) {
                    if (trip.distance) {
                        publicCharging += this.getPublicChargingCost(this.car, trip.distance / 1000, this.annualFrequency(trip));
                    }
                }
            }
            return publicCharging;
        },
        hybridGetFuelCost(mode) {
            let hybridFuel = 0;
            if (mode == "home" || mode == "both") {
                hybridFuel += this.getHybridFuelCost(this.car, this.bubble.kms / 7, 365);
            }
            if (mode == "trips" || mode == "both") {
                for (let trip of this.trips) {
                    if (trip.distance) {
                        hybridFuel += this.getHybridFuelCost(this.car, trip.distance / 1000, this.annualFrequency(trip));
                    }
                }
            }
            return hybridFuel;
        },
        getAnnualKms(mode) {
            let kms = 0;
            if (mode == "home" || mode == "both") {
                kms += this.bubble.kms / 7 * 365;
            }
            if (mode == "trips" || mode == "both") {
                kms += this.getTotalKms(this.trips);
            }
            return kms;
        },
        getHybridFuelCost(car, kms, frequency) {
            let runningCosts = 0;
            if (car.Hybrid == true) {
                let pkms = kms;
                if (this.bubble.chargeAtPark) {
                    pkms -= Math.min(car.Range, kms);
                }

                if (pkms > 0)
                    runningCosts += ((pkms * frequency) / (1/car.EquivalentFuelEfficiency)) * this.settings.petrolCost;
            }
            return runningCosts;
        },
        getPublicChargingCost(car, kms, frequency) {
            let runningCosts = 0;
            if (car.Hybrid != true) {
                let pkms = kms;
                if (this.bubble.chargeAtPark) {
                    pkms -= Math.min(car.Range, kms);
                }
                let topUp = pkms / (car.Range / car.BatterySize);
                if (topUp > 0)
                    runningCosts += ((topUp * frequency) * this.settings.publickWh) + ((topUp * frequency) / car.MaxDC) * 60 * this.settings.publicPerMinute;
            }
            return runningCosts;
        },
        getHomeChargingCost(car, kms, frequency) {
            if (!this.bubble.chargeAtPark) {
                return 0;
            }
            kms = Math.min(car.Range, kms);
            let kWh = kms / (car.Range / car.BatterySize);
            let runningCosts = 0;
            if (car.Hybrid == true) {
                let evkWh = kms / (car.Range / car.BatterySize);
                runningCosts += (evkWh * frequency) * this.settings.homekWh;
                return runningCosts;
            }

            let maxCharge = car.BatterySize * car.SoH * 0.85;
            if (kWh < maxCharge) {
                runningCosts += (kWh * frequency) * this.settings.homekWh;
            } else {
                runningCosts += (maxCharge * frequency) * this.settings.homekWh;
            }
            return runningCosts;
        }
    }
};